import React, { Component } from 'react';

import FilterLink from 'data/containers/filterLink';
import { fadeIn } from 'components/utils/animation';
import './style.css';

class ProjectFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animated: false
        };
    }

    componentDidMount() {
        if (this.props.hasLoaded) {
            fadeIn(this.filters);
            this.setState({
                animated: true
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.hasLoaded &&
            !this.props.isLoading &&
            !this.state.animated
        ) {
            fadeIn(this.filters);
            this.setState({
                animated: true
            });
        }
    }

    render() {
        let { categories } = this.props;
        return (
            <div className="ProjectFilters">
                <div
                    className="ProjectFilters__filters"
                    ref={div => {
                        this.filters = div;
                    }}
                >
                    <FilterLink slug="" title="All work" />
                    {categories.map((item, i) => (
                        <div key={i} className="ProjectFilters__item">
                            <FilterLink {...item} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default ProjectFilters;



// WEBPACK FOOTER //
// ./src/components/organisms/projectFilters/index.js